module.exports = __webpack_public_path__ + "img/guoyang.c361f6df.png";